import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/EstimationTree/ItemRenderer/EstimationRenderer.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { IconButton, ListItemIcon, ListItemSecondaryAction, ListItemText, ListItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link, LinkOff } from '@mui/icons-material';
import * as api from '@gmini/sm-api-sdk';
import { useHover } from '@gmini/utils';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { CalculateIcon, Tooltip } from '@gmini/ui-kit';
import { useClassifierProps } from "../itemPropsCtx";
import { RemoveDependencyDialog } from "../../../RemoveDependencyDialog";
import { ItemTooltip } from "../../ItemTooltip";
import { goals } from "../../../../metrika";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EstimationRenderer = function EstimationRenderer(_ref) {
  var node = _ref.item.payload;

  var _useHover = useHover(),
      hover = _useHover.hover,
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver;

  var _useClassifierProps = useClassifierProps(node),
      currentClassifierData = _useClassifierProps.currentClassifierData,
      included = _useClassifierProps.included,
      isAdded = _useClassifierProps.isAdded;

  var itemListStyles = useItemListStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      loading = _React$useState2[0];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      removeDialogOpen = _React$useState4[0],
      setRemoveDialogOpen = _React$useState4[1];

  var onRemoveDialogClose = React.useCallback(function () {
    return setRemoveDialogOpen(false);
  }, []);
  var removeDependency = React.useCallback(function () {
    if (currentClassifierData) {
      api.UserClassifier.removeDependency.defaultContext.submit({
        id: currentClassifierData.id,
        version: currentClassifierData.version,
        sourceClassifierId: node.classifierId
      });
    }

    removeDialogOpen && setRemoveDialogOpen(false);
  }, [currentClassifierData, node.classifierId, removeDialogOpen]);

  var onRemove = function onRemove() {
    if (included) {
      setRemoveDialogOpen(true);
    } else {
      removeDependency();
    }
  };

  var onAdd = function onAdd() {
    goals.addClassifierDependency();

    if (currentClassifierData) {
      api.UserClassifier.addDependency.defaultContext({
        id: currentClassifierData.id,
        version: currentClassifierData.version,
        sourceClassifierId: node.classifierId,
        sourceClassifierVersion: node.classifierVersion
      });
    }
  };

  var disabledItem = node.status === 'DRAFT';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [removeDialogOpen && /*#__PURE__*/_jsx(RemoveDependencyDialog, {
      name: node.title,
      type: node.type,
      onClose: onRemoveDialogClose,
      removeDependency: removeDependency
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: disabledItem ? 'Отсутствует опубликованная версия расчёта' : '',
      children: /*#__PURE__*/_jsxs(ListItem, {
        dense: true,
        button: true,
        ContainerProps: {
          onMouseLeave: onMouseLeave,
          onMouseOver: onMouseOver
        },
        disabled: disabledItem,
        classes: itemListStyles,
        children: [node.type === 'EstimationNode' && /*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(CalculateIcon, {
            width: 18,
            height: 18
          })
        }), /*#__PURE__*/_jsx(ListItemText, {
          disableTypography: true,
          children: /*#__PURE__*/_jsx(ItemTooltip, {
            title: node.title,
            children: /*#__PURE__*/_jsx(Typography, {
              noWrap: true,
              variant: "body2",
              children: isAdded ? /*#__PURE__*/_jsx("strong", {
                children: node.title
              }) : node.title
            })
          })
        }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
          children: /*#__PURE__*/_jsx(_Fragment, {
            children: loading ? /*#__PURE__*/_jsx(IconButton, {
              size: "small",
              disabled: true,
              children: /*#__PURE__*/_jsx(CircularProgress, {
                size: 24
              })
            }) : hover && /*#__PURE__*/_jsx(IconButton, {
              disabled: disabledItem,
              size: "small",
              onClick: isAdded ? onRemove : onAdd,
              children: isAdded ? /*#__PURE__*/_jsx(LinkOff, {
                color: "error"
              }) : /*#__PURE__*/_jsx(Link, {})
            })
          })
        })]
      })
    })]
  });
};
var useItemListStyles = makeStyles(function () {
  return {
    container: {
      width: '100%'
    }
  };
});